import { render, staticRenderFns } from "./ViewAdmin.vue?vue&type=template&id=c0798660&"
import script from "./ViewAdmin.vue?vue&type=script&lang=js&"
export * from "./ViewAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports